export default __webpack_public_path__ + "static/media/logo-dark-groww.83f43714.2447e35b.svg";